import React from "react";
import { Copy, CheckCircle } from "lucide-react";

const GeneratedLinkCard = ({ generatedLink, copied, copyToClipboard }) => {
  const formatExpiration = (iso) => new Date(iso).toLocaleString();

  return (
    <div className="mt-5 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h3 className="text-lg font-medium text-gray-800">Generated Link</h3>
          <p className="break-words text-sm font-medium text-blue-600">{generatedLink.build_info.name}</p>
          <p className="mt-1 text-xs leading-5 text-gray-500">{generatedLink.build_info.description}</p>
        </div>
        <span className="whitespace-nowrap text-xs text-gray-500 sm:text-sm">Expires: {formatExpiration(generatedLink.expires_at)}</span>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <input
          type="text"
          value={generatedLink.url}
          readOnly
          className="min-w-0 w-full flex-1 truncate rounded-xl border border-gray-300 bg-gray-50 px-3 py-3 text-sm"
        />
        <button
          onClick={() => copyToClipboard(generatedLink.url)}
          className="flex min-h-12 w-full items-center justify-center gap-2 rounded-xl bg-gray-800 px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-gray-900 sm:w-auto"
        >
          {copied === "single" ? <CheckCircle size={16} /> : <Copy size={16} />}
          {copied === "single" ? "Copied!" : "Copy"}
        </button>
      </div>
    </div>
  );
};

export default GeneratedLinkCard;
